import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ActionBtn } from 'src/app/interfaces/action-btn.model';

@Component({
  selector: 'app-user-message-box',
  templateUrl: './user-message-box.component.html',
  styleUrls: ['./user-message-box.component.scss']
})
export class UserMessageBoxComponent implements OnInit {
  @Input() title: string;
  @Input() msg?: string;
  @Input() actionBtns: ActionBtn[];
  @Input() contentBody?: any;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  constructor(public dialogRef: MatDialogRef<UserMessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService) { 
      this.title = data['title'];
      this.actionBtns = data['actionBtns'];
      if('msg' in data && data['msg'].length) {
        this.msg = translate.instant(data['msg']);
      } else if ("content" in data && data['content']) {
        this.contentBody = data['content']
      }
    }

  ngOnInit() {
  }

  closeMenu(){
    this.closeModal.emit(true);
  }

}
